<template>
    <flex-layout>
        <ServiceFaqModal />
        <page-header heading="Service FAQ's" action="Add" toggle="offcanvas" target="#offcanvasCreate"
            :guard="this.$route.meta.guard" @click="setCreateForm" />

        <ServiceFaqTable :tableHeading="tableHeading" />
    </flex-layout>
</template>
  
<script>
import FlexLayout from "@/components/Layout/FlexLayout.vue";
import ServiceFaqTable from "@/components/ServiceFaq/table.vue";
import PageHeader from "@/components/Utility/PageHeader.vue";
import ServiceFaqModal from "@/components/ServiceFaq/modal.vue";
export default {
    name: "ServiceFAQ",
    components: {
        PageHeader,
        FlexLayout,
        ServiceFaqTable,
        ServiceFaqModal
    },
    data() {
        return {
            tableHeading: [
                {
                    heading: "Title",
                },
                {
                    heading: "Product",
                },
                {
                    heading: "Description",
                },
                {
                    heading: "Status",
                },
            ],
        };
    },
    methods: {
        setCreateForm() {
            this.$root.$emit('CREATE');
        },
    }
};
</script>
  